module.exports = __webpack_public_path__ + "img/empty.6edd05f8.png";